// This file was generated using `pay js:run gql-v1 --type=fragment --name=BankAccountExternalAccount --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';
import type {
  Exact,
  OpenapiExternalAccountBankAccountObjectFieldType,
  OpenapiExternalAccountBankAccountAvailablePayoutMethodsEnum,
  OpenapiExternalAccountBankAccountDebitAgreementStatusEnum,
  OpenapiExternalAccountBankAccountDebitAgreementTypeEnum,
} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment BankAccountExternalAccountFragment on OpenapiExternalAccountBankAccount {
    id
    object
    blocklisted
    bank_name
    country
    currency
    default_for_currency
    last4
    routing_number
    available_payout_methods
    created
    status
    bank_connections_account
    account_holder_name
    account_type
    can_confirm
    financial_account
    debit_agreement {
      accepted_at
      status
      type
    }
  }
`;

export const bankAccountExternalAccountFragment: BankAccountExternalAccountFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type BankAccountExternalAccountFragmentData = {
  readonly __typename: 'OpenapiExternalAccountBankAccount';
  readonly id: string;
  readonly object: OpenapiExternalAccountBankAccountObjectFieldType;
  readonly blocklisted: boolean | null;
  readonly bank_name: string | null;
  readonly country: string;
  readonly currency: string;
  readonly default_for_currency: boolean | null;
  readonly last4: string;
  readonly routing_number: string | null;
  readonly available_payout_methods: ReadonlyArray<OpenapiExternalAccountBankAccountAvailablePayoutMethodsEnum> | null;
  readonly created: number;
  readonly status: string;
  readonly bank_connections_account: string | null;
  readonly account_holder_name: string | null;
  readonly account_type: string | null;
  readonly can_confirm: boolean | null;
  readonly financial_account: string | null;
  readonly debit_agreement: {
    readonly __typename: 'OpenapiExternalAccountBankAccountDebitAgreement';
    readonly accepted_at: number;
    readonly status: OpenapiExternalAccountBankAccountDebitAgreementStatusEnum | null;
    readonly type: OpenapiExternalAccountBankAccountDebitAgreementTypeEnum;
  } | null;
};

export type BankAccountExternalAccountFragmentVariables = Exact<{
  [key: string]: never;
}>;

const bankAccountExternalAccountFragmentPermissions = {} as const;

doc.permissions = bankAccountExternalAccountFragmentPermissions;

export type BankAccountExternalAccountFragmentPermissions = V1PermissionToken<
  typeof bankAccountExternalAccountFragmentPermissions
>;

export type BankAccountExternalAccountFragmentDocument = GraphQlDocument<
  BankAccountExternalAccountFragmentData,
  BankAccountExternalAccountFragmentVariables,
  BankAccountExternalAccountFragmentPermissions
>;
